import { IconButton, Input } from '../../../layout/form';

const GeneralTab = ({ values, setValues, next, reset }) => {
  const onChange = ({ target: { id, value } }) =>
    setValues(prev => ({ ...prev, [id]: value }));

  return (
    <div style={{ padding: '1vw' }}>
      <div className="row">
        <div className="col s4 m3 l2">
          <table>
            <tbody>
              <tr>
                <td style={{ padding: '4px', textAlign: 'right' }}>
                  <span className="red-text">*</span>Name
                </td>
              </tr>
              <tr>
                <td style={{ padding: '4px', textAlign: 'right' }}>phone</td>
              </tr>
              <tr>
                <td style={{ padding: '4px', textAlign: 'right' }}>email</td>
              </tr>
              <tr>
                <td style={{ padding: '4px', textAlign: 'right' }}>website</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="col s8 m9 l10">
          <table>
            <tbody>
              <Input
                id="name"
                type="text"
                value={values.name}
                onChange={onChange}
                col="col s12 m6 l5"
              />
              <Input
                id="phone"
                type="text"
                value={values.phone}
                onChange={onChange}
                col="col s12 m6 l5"
              />
              <Input
                id="email"
                type="text"
                value={values.email}
                onChange={onChange}
                col="col s12 m6 l5"
              />
              <Input
                id="website"
                type="text"
                value={values.website}
                onChange={onChange}
                col="col s12 m6 l5"
              />
            </tbody>
          </table>
        </div>
      </div>
      <div className="row" style={{ marginTop: '40px' }}>
        <IconButton icon="arrow_forward" onClick={next} />
        <IconButton icon="refresh" onClick={reset} />
      </div>
    </div>
  );
};

export default GeneralTab;
